import styled from '@emotion/styled'

export const Container = styled.label``

export const TextStyled = styled.span`
  font-size: 14px;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
`
